<script>
  import { portal_url } from "./stores.js";
  import { query } from "./stores.js";
  import { get_parameters } from "./helpers";
  import { onDestroy } from "svelte";
  let options = [
    { id: "Advisory", title: "Advies" },
    { id: "AnnualReport", title: "Jaarverslag" },
    { id: "File", title: "Bestand" },
    { id: "MREvent", title: "Oriëntatiemoment" },
    { id: "Study", title: "Oriëntatienota" },
  ];
  // Define all type ids, as we need them a few times.
  let option_ids = [];
  options.forEach((element) => {
    option_ids.push(element.id);
  });

  // By default we search all except files.
  let chosen = ["Advisory", "AnnualReport", "MREvent", "Study"];
  // But check the current url.
  let params = (new URL(document.location)).searchParams;
  if (params.has("portal_type")) {
    chosen = [params.get("portal_type")];
  };
  function toggle_all() {
    if (chosen.length === options.length) {
      chosen = [];
      return;
    }
    // Slice makes a copy.
    chosen = option_ids.slice();
  }
  $: {
    // This 'magically' gets run whenever 'chosen' changes.
    // See https://svelte.dev/tutorial/reactive-declarations
    let types = chosen.slice();
    // If no types are chosen, we do not search.
    if (types.length) {
      // searching for File should also search on FileAttachment.
      if (chosen.indexOf("File") != -1) {
        types.push("FileAttachment");
      }
      query["portal_type"] = types;
      query.set(query);
    }
  }

  // Remember which facet search we used for the count we show currently.
  // We use this to avoid sending the same query multiple times.
  let current_search_parameters = [];
  const facet_search = async () => {
    let search_url = $portal_url + "/@minaraad_search_facets";
    let facet_query = {};
    Object.assign(facet_query, $query);
    Object.assign(facet_query, { facet: "portal_type" });
    let parameters = get_parameters(facet_query);
    // https://stackoverflow.com/questions/7837456/how-to-compare-arrays-in-javascript#19746771
    if (
      parameters.length === current_search_parameters.length &&
      parameters.every(function (value, index) {
        return value === current_search_parameters[index];
      })
    ) {
      return;
    }
    current_search_parameters = parameters;
    search_url += "?" + parameters.join("&");
    const res = await fetch(search_url, {
      headers: new Headers({ Accept: "application/json" }),
    });
    let results = await res.json();
    let items = results.items;
    if (items === undefined) {
      return;
    }
    options.forEach((option) => {
      option.count = 0;
      items.forEach((element) => {
        let facet = element.facet;
        if (option.id === facet) {
          option.count += element.count;
        }
      });
    });
    options = options;
  };

  // Subscribe to changes of query,
  // and make sure we unsubscribe when we are destroyed.
  const unsubscribe_query = query.subscribe((value) => {
    facet_search();
  });
  onDestroy(unsubscribe_query);
</script>
<div class="faceted-widget">
  <fieldset class="widget-fieldset">
    <legend>Type</legend>
    <ul>
      <li>
        <label>
          <input type="checkbox" on:click={toggle_all} />
          Selecteer alles
        </label>
      </li>

      {#each options as { id, title, count }}
        <li>
          <label>
            <input type="checkbox" bind:group={chosen} value={id} />
            {title} ({count})
          </label>
        </li>
      {/each}
    </ul>
  </fieldset>
</div>



